import { render, staticRenderFns } from "./securityRole.vue?vue&type=template&id=042e303b&scoped=true&"
import script from "./securityRole.vue?vue&type=script&lang=js&"
export * from "./securityRole.vue?vue&type=script&lang=js&"
import style0 from "./securityRole.vue?vue&type=style&index=0&id=042e303b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e303b",
  null
  
)

export default component.exports